export enum OrganizationTypeEnum {
  Business = 'business',
  Education = 'education',
  PublicSector = 'public-sector',
  NonProfit = 'non-profit',
  Student = 'student',
  Other = 'other',
}

export type OrganizationType = `${OrganizationTypeEnum}`;
